import i18n from 'i18next';

export function getTwitterUrl(): string {
  return (i18n.language === 'ru')
    ? 'https://twitter.com/SpotifyUncharRU' : 'https://twitter.com/SpotifyUnchartd';
}
